import React from 'react';
import styled, { css } from 'styled-components';
import { ifProp, palette, prop, theme } from 'styled-tools';
import { AiOutlineFileText } from 'react-icons/ai';
import { BiTask } from 'react-icons/bi';

export const Wrapper = styled.main`
  display: flex;
  place-content: space-between;
  align-items: center;
  gap: 0 10px;
`;

type TActivityItemForm = {
  allowClick?: boolean;
};
export const ActivityItemForm = styled.form<TActivityItemForm>`
  display: flex;
  flex-direction: row;
  place-content: space-between;
  align-items: center;
  flex: 1;
  position: relative;

  cursor: ${ifProp('disabled', '', ifProp('allowClick', 'pointer', ''))};
  color: ${ifProp('disabled', palette('grey'), palette('dark'))};

  font-style: ${ifProp('disabled', 'italic', 'normal')};
  ${theme('components.ActionItem.container')}
`;

type ActivityItemProperties = {
  textNote?: boolean;
  disabled?: boolean | undefined;
  allowClick?: boolean | undefined;
};
export const ActivityItem = styled.div<ActivityItemProperties>`
  display: flex;
  flex-direction: row;
  place-content: space-between;
  align-items: center;
  flex: 1;
  position: relative;
  cursor: ${ifProp('disabled', '', ifProp('textNote', '', 'pointer'))};
  margin: 2px 0;
  color: ${ifProp('disabled', palette('grey'), palette('dark'))};

  font-style: ${ifProp('disabled', 'italic', 'normal')};
  border-left: 8px solid ${palette('primary')};
  border-radius: ${theme('borderRadius.sm')} 0 0 ${theme('borderRadius.sm')};
  ${theme('components.ActionItem.container')}
  [type="button"] {
    display: none;
    transform: scale(1);
  }
  &:hover {
    [type='button'] {
      display: flex;
    }
  }
`;

export const WorkItemId = styled.span`
  font-family: ${theme('fontFamily')};
  font-size: 12px;
  color: ${palette('primary')};
  margin-right: 8px;
`;

export const ActivityLabel = styled.div<any>`
  color: ${ifProp(
    'disabled',
    palette('colorActivityInputDisabled'),
    palette('colorActivityInput')
  )};

  flex: 1;
  font-family: ${theme('fontFamily')};
  background-color: ${palette('bgActivityInputReadyOnly')};
  border-bottom: 1px solid ${palette('borderActivityInput')};
  border-top: 1px solid ${palette('borderActivityInput')};
  border-right: 1px solid ${palette('borderActivityInput')};
  padding: ${ifProp('hasIcon', '10px 10px 10px 26px', '10px')};
  transition: ${theme('transition')};
  border-radius: 0 4px 4px 0;
  padding-left: ${ifProp('textNote', '25px', '')};
`;

type ActivityInputProperties = {
  allowEdit?: boolean;
  allowRemove?: boolean;
  hasDropdown?: boolean;
  hasIcon?: boolean;
  hasError?: boolean;
  ref: React.Ref<HTMLInputElement>;
};
export const ActivityInput = styled.input<ActivityInputProperties>`
  flex: 1;
  font-family: ${theme('fontFamily')};
  color: ${ifProp(
    'disabled',
    palette('colorActivityInputDisabled'),
    palette('colorActivityInput')
  )};
  display: block;
  margin: 0;
  border: none;
  background-color: ${ifProp(
    'readOnly',
    palette('bgActivityInputReadyOnly'),
    palette('bgActivityInput')
  )};
  border-bottom: 1px solid ${palette('borderActivityInput')};
  border-top: 1px solid ${palette('borderActivityInput')};
  border-right: 1px solid ${palette('borderActivityInput')};

  border-color: ${ifProp('hasError', palette('danger'), 'none')};
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: ${ifProp(
    'hasDropdown',
    '38px',
    ifProp('hasIcon', '26px', '10px')
  )};
  padding-right: ${({ allowEdit, allowRemove }) =>
    allowEdit || allowRemove ? '30px' : '10px'};

  outline: none;
  transition: ${theme('transition')};
  border-radius: ${ifProp('readOnly', '0 4px 4px 0', '0')};

  &:focus {
    border-top-color: ${ifProp(
      'readOnly',
      palette('borderActivityInput'),
      ifProp('hasError', palette('danger'), palette('primary'))
    )};
    border-bottom-color: ${ifProp(
      'readOnly',
      palette('borderActivityInput'),
      ifProp('hasError', palette('danger'), palette('primary'))
    )};
    border-right-color: ${ifProp(
      'readOnly',
      palette('borderActivityInput'),
      ifProp('hasError', palette('danger'), palette('primary'))
    )};
  }
`;

type ActivityLinkButtonProperties = {
  right?: string;
  invisible?: boolean;
  width?: string;
};
export const ActivityLinkButton = styled.button<ActivityLinkButtonProperties>`
  width: ${ifProp('width', prop('width'), '60px')};
  position: absolute;
  right: ${({ right }) => `${right || '10px'}`};
  height: 100%;
  display: flex;
  align-items: center;
  place-content: end;
  justify-content: end;
  background: transparent;
  border: none;
  margin: 0;
  color: ${ifProp('disabled', palette('gray'), palette('colorActivityInput'))};
  user-select: none;
  cursor: pointer;
  text-align: center;
  opacity: ${ifProp('invisible', 0, 1)};
`;

type TriggerDropdownProperties = {
  textNote?: boolean | undefined;
};
export const TriggerDropdown = styled.div<TriggerDropdownProperties>`
  position: absolute;
  left: 0;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 5px;
  user-select: none;
`;

export const ActionItemIcon = styled(TriggerDropdown)``;

export const TriggerDropdownIcon = styled.img`
  width: 14px;
  height: auto;
  margin-right: 5px;
`;

const iconStyle = css`
  margin-right: 7px;
  color: ${palette('colorBody')};
  transition: ${theme('transition')};
`;

export const TextNoteIcon = styled(AiOutlineFileText)<any>`
  ${iconStyle}
`;
export const MondayIcon = styled(BiTask)`
  ${iconStyle}
`;
